<template>
  <div>
    <h2 class="mb-1">Plan: {{ product && product.name }}</h2>
    <p class="mb-2 font12 font800">Users: {{ activeUserCount }}</p>
    <FeatureList :planHandle="product.handle" />
    <v-row no-gutters v-if="type !== 'upgrade'">
      <x-button
        v-if="canManage"
        color="primary"
        buttonText="Change Plan"
        class="mt-5 pa-1 change__plan__btn"
        @click="openDialog"
        :outline="true"
        :data-test-id="`${dataTestId}__change-plan-btn`"
      />
    </v-row>
  </div>
</template>
<script>
import FeatureList from './SubscriptionPlanFeatureList';
export default {
  name: 'CurrentSubscriptionCard',
  props: [
    'isOrgOnboarded',
    'product',
    'heading',
    'type',
    'components',
    'subscriptionsId',
    'canManage',
    'activeUserCount',
    'dataTestId'
  ],
  components: { FeatureList },
  methods: {
    openDialog() {
      if (this.isOrgOnboarded) {
        this.$emit('openDialog', true);
      } else {
        this.snackbar(
          'info',
          this.$message.ACTION_RESTRICTION_WHILE_ONBOARDING
        );
      }
    }
  }
};
</script>
<style scoped>
.change__plan__btn {
  font-size: 12px;
  width: 100px !important;
}
</style>
